<script>
	import Vue from 'vue';
	import Store from 'kvstore';
	import optimizedResize from 'utilities/optimizedResize';

	export default {
		props: {
			text: {
				type: String
			},
			label: {
				type: String
			},
			lines: {
				type: Number,
				default: 1
			},
			focusableWrapper: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isOverflowing: false,
				showDialog: false,
				guid: Store.inc('overflowTextGuid'),
				hideTimeout: null,
				hideInterval: 125
			};
		},
		computed: {
			renderButton() {
				return this.isOverflowing && (!!this.label || !this.focusableWrapper);
			}
		},
		methods: {
			checkOverflow() {
				const el = this.$refs.overflowContent;
				if (el) {
					const { clientHeight, scrollHeight } = el;
					this.isOverflowing = scrollHeight > clientHeight;
				}
			},
			show() {
				if (this.isOverflowing) {
					clearTimeout(this.hideTimeout);
					this.hideTimeout = null;
					this.showDialog = true;
				}
			},
			hide() {
				this.hideTimeout = setTimeout(() => {
					this.showDialog = false;
				}, this.hideInterval);
			}
		},
		mounted() {
			Vue.nextTick(() => {
				this.checkOverflow();
				optimizedResize.add(this.checkOverflow);
			});
		},
		beforeDestroy() {
			optimizedResize.remove(this.checkOverflow);
		}
	};
</script>
<style lang="scss">
	.overflow-text {
		position: relative;
		display: inline-flex;
		justify-content: center;

		.overflow-text-wrapper {
			display: inline-flex;
			align-items: center;
			padding: 0;
			appearance: none;
			border: none;
			background: none;
			text-align: left;
		}

		.overflow-text-content {
			display: -webkit-box;
			-webkit-line-clamp: var(--overflow-text-line-clamp, 1);
			/*! autoprefixer: off */
			-webkit-box-orient: vertical;
			/*! autoprefixer: on */
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.overflow-dialog {
			position: absolute;
			font-size: 0.875rem;
			top: calc(100% + 0.75rem);
			width: 15rem;
			padding: 1rem;

			&.hidden-visually {
				padding: 0;
				width: 0;
			}
		}

		.help-dialog-title {
			flex-basis: 100%;
			margin: 0 0 0.5rem;
		}

		.help-dialog-body {
			margin: 0;
		}
	}
</style>
<template>
	<div
		v-if="text"
		class="overflow-text"
		@mouseenter="show"
		@mouseleave="hide">
		<component
			class="overflow-text-wrapper"
			:is="renderButton ? 'button' : 'span'"
			:type="renderButton ? 'button' : null"
			:aria-describedby="label ? `overflow-text-label-${guid}` : null"
			@focus="show"
			@blur="hide"
			@keydown.esc="hide">
			<span
				class="overflow-text-content"
				:style="{ '--overflow-text-line-clamp': this.lines }"
				v-text="text"
				ref="overflowContent"></span>
		</component>
		<div
			class="overflow-dialog help-dialog dialog-bottom"
			:class="{
				'hidden-visually': !showDialog
			}">
			<p
				class="overflow-label help-dialog-title"
				role="tooltip"
				:id="`overflow-text-label-${guid}`"
				v-if="label"
				v-text="label"></p>
			<p
				class="help-dialog-body"
				v-text="text"></p>
		</div>
	</div>
</template>
